<template>
  <div>
    <base-button block type="primary" class="m-0" @click="modal = true"
                 :disabled="discounts === undefined || discounts.length == 0">
      {{ $t('fares.create.btnLabel') }}
    </base-button>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('fares.create.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('fares.create.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('fares.details.fare_group_id') }}</label>
            <div class="col-md-9">
              <base-input
                  disabled
                  data-vv-as="'fareGroupId'"
                  v-model="fareGroupId">
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('generic.discountID') }}</label>
            <div class="col-md-9">
              <base-input>
                <el-select
                    class="select-primary"
                    :placeholder="$t('fares.form.discountIdPlaceholder')"
                    v-model="formDetails.discount_id">
                  <el-option
                      v-for="option in discounts"
                      class="select-primary"
                      :value="option.id"
                      :label="option.id"
                      :key="option.id">
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('fares.details.municipality_id') }}</label>
            <div class="col-md-9">
              <base-input>
                <el-select
                    clearable
                    class="select-primary"
                    :placeholder="$t('fares.form.municipalityIdPlaceholder')"
                    v-model="formDetails.municipality_id">
                  <el-option
                      v-for="option in municipalities"
                      class="select-primary"
                      :value="option.id"
                      :label="option.id + ' - ' + option.name"
                      :key="option.id">
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('fares.details.starts_at') }}</label>
            <div class="col-md-9">
              <!--              v-validate="modelValidations.required"-->
              <base-input
                  :error="getError('starts_at')">
                <el-date-picker
                    data-vv-as="'startsAt'"
                    name="starts_at"
                    v-validate="modelValidations.required"
                    type="date"
                    v-model="formDetails.starts_at"
                    placeholder="Pick start date"
                    :picker-options="pickerOptions">
                </el-date-picker>
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('fares.details.ends_at') }}</label>
            <div class="col-md-9">
              <base-checkbox
                  v-model="formDetails.ends_at_provided"
                  name="ends_at_provided"
              >{{ $t('fares.form.endsAtProvidedPlaceholder') }}
              </base-checkbox>
              <!--              v-validate="modelValidations.required"-->
              <base-input
                  :error="getError('ends_at')">
                <el-date-picker
                    :disabled="!formDetails.ends_at_provided"
                    data-vv-as="'startsAt'"
                    name="starts_at"
                    v-validate="modelValidations.optional"
                    type="date"
                    v-model="formDetails.ends_at"
                    placeholder="Pick end date"
                    :picker-options="endAtPickerOptions">
                </el-date-picker>
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('generic.description') }}</label>
            <div class="col-md-9">
              <base-input
                  type="text"
                  data-vv-as="'description'"
                  name="description"
                  v-validate="modelValidations.required"
                  :error="getError('description')"
                  v-model="formDetails.description"/>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('fares.details.price') }}</label>
            <div class="col-md-9">
              <base-input
                  type="number"
                  data-vv-as="'price'"
                  name="price"
                  v-validate="modelValidations.positive"
                  :error="getError('price')"
                  v-model.number="formDetails.price"
                  step="0.01"/>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('fares.details.month_price') }}</label>
            <div class="col-md-9">
              <base-checkbox
                  v-model="formDetails.month_cap"
                  name="month_cap"
              >{{ $t('fares.form.monthCapProvidedPlaceholder') }}
              </base-checkbox>
              <base-input
                  :disabled="!formDetails.month_cap"
                  type="number"
                  data-vv-as="'month-price'"
                  name="month_price"
                  v-validate="modelValidations.positive"
                  :error="getError('month_price')"
                  v-model.number="formDetails.month_price"
                  step="0.01"/>
            </div>
          </div>

          <div class="text-center">
            <base-button
                type="primary"
                :loading="updating"
                class="my-4"
                native-type="submit"
            >{{ $t('fares.create.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {DatePicker, Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'new-fare-group-btn',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    Modal,
    BaseAlert
  },
  props: {
    fareGroupId: {
      type: String,
      required: true,
    },
    discounts: {
      type: Array,
      required: true,
    },
    municipalities: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        discount_id: 'DISCOUNT_50',
        starts_at: new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() + 1),
        ends_at_provided: false,
        ends_at: new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() + 2),
        description: '',
        price: 0,
        month_cap: false,
        month_price: 0,
        fare_group_id: '',
        municipality_id: ''
      },
      modelValidations: {
        required: {
          required: true
        },
        positive: {
          min_value: 0
        }
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      endAtPickerOptions: {
        disabledDate(time) {
          return time.getTime() < (Date.now() + 86400000); // Eat least one day
        },
      }
    }
  },

  computed: {
    ...mapState({
      updating: state => state.fare_group_fares.updating,
      error: state => state.fare_group_fares.error,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    }
  },
  methods: {
    ...mapActions(['CreateFare', 'LoadFareGroupFares']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      let caps = {
        calendar_month: {
          price: Math.trunc(this.formDetails.month_price * 100),
        },
      };

      if (!this.formDetails.month_cap) {
        caps = null;
      }

      let payload = {
        discount_id: this.formDetails.discount_id,
        municipality_id: this.formDetails.municipality_id === '' ? null : this.formDetails.municipality_id,
        pricing: {
          single: {
            price: Math.trunc(this.formDetails.price * 100),
          },
          caps: caps
        },
        fare_group_id: this.fareGroupId,
        starts_at: this.formDetails.starts_at,
        ends_at: this.formDetails.ends_at_provided ? this.formDetails.ends_at : null,
        description: this.formDetails.description,
      }

      this.CreateFare(payload).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('fares.create.createdNotification', {
              discount_id: payload.discount_id,
              starts_at: this.$options.filters.dateOnly(payload.starts_at)
            }),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.LoadFareGroupFares(this.fareGroupId);
          this.resetForm();
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        discount_id: 'DISCOUNT_50',
        starts_at: new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() + 1),
        ends_at_provided: false,
        ends_at: new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() + 2),
        description: '',
        price: 0,
        month_cap: false,
        month_price: 0,
        fare_group_id: ''
      };

      // reset validation errors
      this.$validator.reset()
    }
  },
}
</script>
